
import { useDispatch, useSelector} from "react-redux";
import { useDedupEffect } from "@npd-ng/adp-component-library";
import { useFetchService } from "../hooks/useFetchService";
import { IADPState } from "../typings/AppStateTypes";
import { environment } from "../util";
import { createFailureAction, createLaunchFailureAction } from "../state/reducer";
import { LoggPrefix } from "../util/constants";

export function useServerStatus(probeUrl= "ping",probeExpectedValue="Healthy") {
  const {fetch} = useFetchService(); 
  const dispatch = useDispatch();  
  const url = `${environment.resolveENAEPDomain()}/${probeUrl}`
  const state = useSelector(
    (state: { rootState: IADPState }) => state.rootState
  );     
  useDedupEffect(() => {
    if(state.sessionState.networkConnectionState === "Connected" && state.appState.resourcesLoaded){
        console.log(LoggPrefix,"[ServerStatus]", "device has wifi connection, validate online server status");
        //check online
        fetch(url,{method:"GET"}).then((response)=>{
         if(response!==probeExpectedValue){
            console.warn(LoggPrefix,'[ServerStatus] eNAEP servers are not reachable. API Error or Captive portal might be in the middle. Response:', response);
            dispatch(createLaunchFailureAction({error:"ServerError",errorDetails:{timeStamp: new Date(),errorMessage:`eNAEP servers are not reachable. Error:${response}`}}))
            dispatch(createFailureAction("NoServerConnectionDetected"));  
         }
       })
    }
  },[state.sessionState.networkConnectionState]);
 }


